// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5LVzG","rootMobile":"styles_rootMobile__1lenz"};